import styled from '@emotion/styled';
import {LabelXSmallBold} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Breadcrumbs} from '@/modules/common/components/Breadcrumbs/Breadcrumbs';

export const BreadcrumbsHotelsPage = styled(({...restProps}) => {
  const {t} = useTranslation('breadcrumb');

  return (
    <Breadcrumbs {...restProps}>
      <LabelXSmallBold>{t('hotels')}</LabelXSmallBold>
    </Breadcrumbs>
  );
})``;
